import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "@/services/API";
import { validateTrailerType } from "@/utils/validation";
import { today } from "@/utils/date";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getComparisonAndConfidence = createAsyncThunk(
  "search/get-comparison-and-confidence",
  async ({ trailerType, pickupZip, pickupDate }, { rejectWithValue, getState }) => {
    const { user } = getState();
    const isLocked = !(user.data?.featuresUnlocked ?? false);

    if (isLocked) {
      return { comparison: "HIGHPRICE", confidence: "medium" };
    }

    if (!trailerType || !pickupZip || !validateTrailerType(trailerType) || isNaN(pickupZip)) {
      return rejectWithValue("Invalid comparison and confidence parameters provided");
    }

    return API.get("/analytics/outbound-comparison-and-confidence", {
      params: {
        departure: pickupZip,
        "for-date": pickupDate || today,
        trailer: trailerType,
        "use-other-sources": true,
      },
    })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        console.error("Error fetching comparison and confidence data", err);
        return rejectWithValue(err);
      });
  },
);

const marketPotentialSlice = createSlice({
  name: "marketPotential",
  initialState,
  reducers: {
    clearMarketPotentialState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getComparisonAndConfidence.pending, () => ({
        data: null,
        loading: true,
        error: null,
      }))
      .addCase(getComparisonAndConfidence.fulfilled, (_, action) => ({
        data: action.payload,
        loading: false,
        error: null,
      }))
      .addCase(getComparisonAndConfidence.rejected, () => ({
        data: null,
        loading: false,
        error: "Error getting market potential data",
      }));
  },
});

export const { clearMarketPotentialState } = marketPotentialSlice.actions;
export default marketPotentialSlice.reducer;
